import moment from "moment";
import { IS_VALID } from "utils";

var Parse = require('parse');

let schema = {
  className: "EVoucher",
  classNameLabel: "EVOUCHER",
  limit: 10,
  deleteColumn: "title",
  columns: [
    {
      columnName: "objectId",
      type: "string"
    },
    {
      columnName: "title",
      type: "string",
      style: {
        whiteSpace: "normal",
        minWidth: "300px"
      }
    },
    {
      columnName: "descriptions",
      type: "string",
      style: {
        whiteSpace: "normal",
        minWidth: "300px"
      },
      show: false
    },
    {
      columnName: "status",
      type: "string"
    },
    {
      columnName: "Merchant",
      type: "Pointer",
      targetClass: "Merchant",
      displayColumn: "name",
      show: false
    },
    {
      columnName: "campaignCategory",
      columnLabel: "campaign Category",
      type: "Pointer",
      targetClass: "CampaignCategory",
      displayColumn: "title",
      show: true,
      style: {
        whiteSpace: "normal",
        minWidth: "300px"
      }
    },
    {
      columnName: "typeK",
      type: "Pointer",
      targetClass: "VoucherType",
      displayColumn: "name",
      show: false
    },
    {
      columnName: "pointType",
      columnLabel: "POINT TYPE",
      type: "Pointer",
      targetClass: "VoucherPointType",
      displayColumn: "name",
      show: false
    },
    {
      columnName: "welcomeDays",
      columnLabel: "WELCOME DAYS",
      type: "Number",
      show: false
    },
    {
      columnName: "campaignStartDate",
      columnLabel: "CAMPAIGN START DATE",
      type: "Date",
      format: "MMM D, YYYY hh:mm A"
    },
    {
      columnName: "campaignEndDate",
      columnLabel: "CAMPAIGN END DATE",
      type: "Date",
      format: "MMM D, YYYY hh:mm A"
    },
    {
      columnName: "requiredEarningAmount",
      columnLabel: "REQUIRED EARNING AMOUNT",
      type: "Number",
      show: false
    },
    {
      columnName: "earningPeriod",
      columnLabel: "EARNING PERIOD",
      type: "Pointer",
      targetClass: "VoucherEarningPeriod",
      displayColumn: "name",
      show: false
    },
    {
      columnName: "voucherValidityType",
      columnLabel: "VOUCHER VALIDITY TYPE",
      type: "Pointer",
      targetClass: "voucherValidityType",
      displayColumn: "name",
      show: false
    },
    {
      columnName: "voucherValidityDays",
      columnLabel: "VOUCHER VALIDITY DAYS",
      type: "Number",
      show: false
    },
    {
      columnName: "maxVoucherQuantity",
      columnLabel: "MAX VOUCHER QUANTITY",
      type: "Number",
      show: false
    },
    {
      columnName: "maxVoucherQuantityPerDay",
      columnLabel: "MAX VOUCHER QUANTITY PER DAY",
      type: "Number",
      show: false
    },
    {
      columnName: "maxVoucherQuantityPerUser",
      columnLabel: "MAX VOUCHER QUANTITY PER USER",
      type: "Number",
      show: false
    },
    {
      columnName: "maxVoucherQuantityPerUserPerDay",
      columnLabel: "MAX VOUCHER QUANTITY PER USER PER DAY",
      type: "Number",
      show: false
    },
    {
      columnName: "serialNumberPrefix",
      columnLabel: "SERIAL NUMBER PREFIX",
      type: "string",
      show: false
    },
    {
      columnName: "promoCategory",
      columnLabel: "promo Category",
      type: "Pointer",
      targetClass: "VoucherPromoCategory",
      displayColumn: "name",
      show: false
    },
    {
      columnName: "image",
      type: "ParseFile",
      show: false
    },
    {
      columnName: "manualDispense",
      type: "string",
      show: false
    },
    {
      columnName: "createdBy",
      type: "Pointer",
      targetClass: Parse.User,
      displayColumn: "name",
      show: false
    },
    {
      columnName: "updatedBy",
      type: "Pointer",
      targetClass: Parse.User,
      displayColumn: "name",
      show: false
    },
    {
      columnName: "createdAt",
      type: "Date"
    },
    {
      columnName: "updatedAt",
      type: "Date"
    }
  ]
};

module.exports = schema;



// WEBPACK FOOTER //
// ./components/schema/EVoucher.js